import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]
  static values = { interval: { type: Number, default: 10000 } } // 10 seconds default

  connect() {
    this.index = 0
    if (this.slideTargets.length > 1) {
      this.showCurrentSlide()
      this.timer = setInterval(() => {
        this.nextSlide()
      }, this.intervalValue)
    } else if (this.slideTargets.length === 1) {
      this.slideTargets[0].classList.remove("hidden", "opacity-0")
      this.slideTargets[0].classList.add("opacity-100")
    }
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  nextSlide() {
    this.slideTargets[this.index].classList.remove("opacity-100", "z-10")
    this.slideTargets[this.index].classList.add("opacity-0", "z-0")
    
    this.index = (this.index + 1) % this.slideTargets.length
    
    this.slideTargets[this.index].classList.remove("hidden")
    // small timeout to allow display:block to apply before fading in
    setTimeout(() => {
      this.slideTargets[this.index].classList.remove("opacity-0", "z-0")
      this.slideTargets[this.index].classList.add("opacity-100", "z-10")
    }, 50)
  }

  showCurrentSlide() {
    this.slideTargets.forEach((slide, i) => {
      if (i === this.index) {
        slide.classList.remove("hidden", "opacity-0", "z-0")
        slide.classList.add("opacity-100", "z-10")
      } else {
        slide.classList.remove("opacity-100", "z-10")
        slide.classList.add("opacity-0", "z-0")
      }
    })
  }
}
